/**
 * \u9759\u6001\u661f\u91ce\uff08\u7f8e\u672f\u5723\u7ecf \u00a76.5\uff09\u2014\u2014 \u786e\u5b9a\u6027\u4f2a\u968f\u673a\uff0c\u4e00\u6b21\u70d8\u7119\uff0c\u6bcf\u5e27\u96f6\u91cd\u7ed8\u3002
 * seed \u56fa\u5b9a\u4e3a 20261012\uff08\u4e0e\u539f\u578b\u4e00\u81f4\uff09\uff0c\u4fdd\u8bc1\u6bcf\u6b21\u6253\u5f00\u661f\u56fe\u4e00\u81f4\u3002
 */

export interface StarfieldOpts {
  width: number;
  height: number;
  /** \u661f\u70b9\u6570\uff08\u684c\u9762 220\u2013320 / \u79fb\u52a8 90\u2013140\uff09 */
  count: number;
}

const SEED = 20261012;

/** mulberry32\uff1a\u786e\u5b9a\u6027 PRNG */
function rng(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * \u70d8\u7119\u4e00\u5f20\u661f\u91ce\u79bb\u5c4f\u56fe\u3002
 * L0 \u5e95\u8272 \u2192 L1 \u5e95\u886c\u5fc3 \u2192 L2 \u661f\u4e91A \u2192 L3 \u661f\u4e91B \u2192 L4 \u661f\u70b9\u4e09\u5c42\u5f84\u4e0e\u4e09\u6863\u4eae\u5ea6
 */
export function bakeStarfield(opts: StarfieldOpts): HTMLCanvasElement {
  const { width, height, count } = opts;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return canvas;

  // L0 \u5e95\u8272
  ctx.fillStyle = '#0B1020';
  ctx.fillRect(0, 0, width, height);

  const rand = rng(SEED);

  // L1 \u5e95\u886c\u5fc3
  const core = ctx.createRadialGradient(
    width * 0.32, height * 0.28, 0,
    width * 0.32, height * 0.28, Math.max(width, height) * 0.72,
  );
  core.addColorStop(0, 'rgba(58,46,110,0.62)');
  core.addColorStop(0.45, 'rgba(34,48,94,0.34)');
  core.addColorStop(1, 'rgba(11,16,32,0)');
  ctx.fillStyle = core;
  ctx.fillRect(0, 0, width, height);

  // L2 \u661f\u4e91 A\uff08\u7d2b\uff09
  ctx.save();
  ctx.globalAlpha = 0.20;
  ctx.fillStyle = '#5B3F9E';
  ctx.beginPath();
  ctx.ellipse(width * 0.72, height * 0.24, width * 0.42, height * 0.20, 0.5, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();

  // L3 \u661f\u4e91 B\uff08\u9752\uff09
  ctx.save();
  ctx.globalAlpha = 0.16;
  ctx.fillStyle = '#1E5C7A';
  ctx.beginPath();
  ctx.ellipse(width * 0.24, height * 0.74, width * 0.38, height * 0.18, -0.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();

  // L4 \u661f\u70b9\u4e09\u5c42
  for (let i = 0; i < count; i++) {
    const x = rand() * width;
    const y = rand() * height;
    const layer = rand();
    const radius = layer < 0.68 ? 0.6 + rand() * 0.5 : layer < 0.93 ? 1.0 + rand() * 0.5 : 1.6 + rand() * 0.9;
    const alpha = 0.15 + rand() * 0.5;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.fillStyle = '#E8EFFA';
    ctx.beginPath();
    ctx.arc(x, y, radius, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();

    // \u5927\u661f\u52a0\u56db\u8292\u661f\u9488
    if (radius > 1.6) {
      ctx.save();
      ctx.globalAlpha = alpha * 0.45;
      ctx.strokeStyle = '#E8EFFA';
      ctx.lineWidth = 0.7;
      const L = radius * 3.4;
      ctx.beginPath();
      ctx.moveTo(x - L, y); ctx.lineTo(x + L, y);
      ctx.moveTo(x, y - L); ctx.lineTo(x, y + L);
      ctx.stroke();
      ctx.restore();
    }
  }

  return canvas;
}
